// extracted by mini-css-extract-plugin
export default {"Text":"use-select-panel-module__Text__qmTEXhV"};